import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing(1),
  },
  navigationActions: {
    alignItems: 'center',
    display: 'flex',
    marginRight: theme.spacing(2),
  },
  navigationButton: {
    backgroundColor: theme.palette.action.active,
    color: theme.palette.common.white,
    height: 32,
    padding: theme.spacing(0.75),
    width: 32,
    '&:hover': {
      backgroundColor: theme.palette.text.primary,
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  },
  text: {},
}));
